package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.browser.uri.encodeURIComponent
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import io.horion.cv.utils.Colors
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.utils.Constants.AUTH_FRONTEND_URL
import io.horion.cv.api.utils.TokenRepository
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.pages.navigation.links
import io.horion.cv.styles.ActionButtonsRowStyle
import io.horion.cv.styles.BrandingStyle
import io.horion.cv.styles.CreateButtonStyle
import io.horion.cv.styles.CreateCvButtonStyle
import io.horion.cv.styles.CreateCvButtonTextStyle
import io.horion.cv.styles.DesktopNavContainerStyle
import io.horion.cv.styles.LoginButtonStyle
import io.horion.cv.styles.LoginButtonTextStyle
import io.horion.cv.styles.LogoStyle
import io.horion.cv.styles.MobileMenuBurgerStyle
import io.horion.cv.styles.ThemeIconStyle
import io.horion.cv.styles.TopbarStyle
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.window
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Text

@Composable
fun Topbar() {

    var showMenu by remember { mutableStateOf(false) }
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val topbarBg = if (isDark) Colors.DarkBG else Colors.White
    val borderColor = if (isDark) Colors.holder else Colors.LightGray

    Row(
        modifier = TopbarStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(topbarBg)
            .border(
                width = 1.px,
                style = LineStyle.Solid,
                color = borderColor
            )
            .boxShadow(
                offsetX = 0.px,
                offsetY = 1.px,
                blurRadius = 6.px,
                spreadRadius = 1.px,
                color = rgba(0, 0, 0, 0.1)
            )
            .styleModifier {
                property("transition", "background-color 300ms ease")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Branding(isDark=isDark)

        Spacer()

        Row(
            modifier = DesktopNavContainerStyle.toModifier(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            links.forEach { (title, path) ->
                NavLink(title, path)
            }
        }

        Spacer()

        ActionButtons() {
            showMenu = true
        }
    }

    if (showMenu) {
        MobileSidebar {
            showMenu = false
        }
    }
}

@Composable
fun Branding(isDark: Boolean = false) {
    Link(
        path = Screen.Home.path, modifier = BrandingStyle.toModifier()
    ) {
        if (isDark){
            Image(
                src = "/logo-CV-new-blanc.png",
                description = "Logo image",
                modifier = LogoStyle.toModifier()
                //  .height(if (breakpoint <= Breakpoint.MD) 32.px else 40.px)
            )
        }else {
            Image(
                src = "/logo-CV-new-bleu-nuit.png",
                description = "Logo image",
                modifier = LogoStyle.toModifier()
                //  .height(if (breakpoint <= Breakpoint.MD) 32.px else 40.px)
            )
        }
    }
}

@Composable
fun ActionButtons(
    onMenuClick: () -> Unit
) {
    val ctx = rememberPageContext()
    var colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    var isAuthenticated by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        isAuthenticated = runCatching { TokenRepository.checkAuthentication() }.getOrDefault(false)
    }


    Row(
        modifier = ActionButtonsRowStyle.toModifier(),
        verticalAlignment = Alignment.CenterVertically
    ) {

        if (isAuthenticated) {
            Button(
                onClick = { ctx.router.navigateTo(Screen.Dashboard.path) },
                modifier = CreateButtonStyle.toModifier()
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Bold)
                    .borderRadius(15.px)
                    .color(Colors.White),
            ) {
                Text("Dashboard")
            }
        } else {
            Button(
                onClick = { ctx.router.navigateTo(Screen.CV.path)},
                modifier = CreateButtonStyle.toModifier()
                    .then(CreateCvButtonStyle.toModifier())
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Bold)
                    .borderRadius(19.px)
                    .color(Colors.White),
            ) {
                SpanText(
                    text = "Créer un cv",
                    modifier = CreateCvButtonTextStyle.toModifier()
                )
            }

            Button(
                onClick = {
                    val returnUrl = window.location.pathname + window.location.search
                    val currentUrl = window.location.href
                    window.location.href = "$AUTH_FRONTEND_URL?redirect=${encodeURIComponent(currentUrl)}"
                },
                modifier = LoginButtonStyle.toModifier()
                    .fontFamily(INTER)
                    .backgroundColor(Colors.White)
                    .fontWeight(FontWeight.Bold)
                    .borderRadius(19.px)
                    .border(2.px, LineStyle.Solid, Colors.bluelight)
                    .color(Colors.bluelight)
            ) {
                SpanText(
                    text = "Connexion",
                    modifier = LoginButtonTextStyle.toModifier()
                )
            }
        }

        if (isDark) {
            FaSun(
                modifier = ThemeIconStyle.toModifier()
                    .color(Colors.yellow)
                    .onClick { colorMode = colorMode.opposite }
            )
        } else {
            FaMoon(
                modifier = ThemeIconStyle.toModifier()
                    .color(Colors.Primary)
                    .onClick { colorMode = colorMode.opposite }
            )
        }

        Box(
            modifier = MobileMenuBurgerStyle.toModifier()
        ) {
            FaBars(
                modifier = Modifier
                    .color(if (isDark) Colors.White else Colors.Black)
                    .onClick { onMenuClick() }
            )
        }

    }
}

@Composable
fun MobileSidebar(onClose: () -> Unit) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val sidebarBg = if (isDark) Colors.DarkBG else Colors.White

    Overlay(
        modifier = Modifier
            .backgroundColor(Colors.Black.copy(alpha = 128))
            .zIndex(1000)
            .onClick { onClose() }
    ) {
        Box(
            modifier = Modifier
                .fillMaxHeight()
                .width(280.px)
                .backgroundColor(sidebarBg)
                .align(Alignment.TopEnd)
                .padding(all = 20.px)
                .onClick { it.stopPropagation() }
                .boxShadow(
                    offsetX = 0.px,
                    offsetY = 1.px,
                    blurRadius = 6.px,
                    spreadRadius = 1.px,
                    color = rgba(0, 0, 0, 0.1)
                )
        ) {
            Column {
                Row(
                    modifier = Modifier
                        .fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Spacer()

                    FaXmark(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() }
                            .fontSize(24.px)
                            .color(if (isDark) Colors.White else Colors.Black)
                    )
                }
                Column(
                    modifier = Modifier
                        .margin(top = 40.px)
                        .gap(25.px)
                ) {
                    links.forEach { (title, path) ->
                        NavLinkSidebar(title, path, onClose)
                    }
                }
            }
        }
    }
}

@Composable
fun NavLink(
    text: String,
    path: String
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val linkColor = if (isDark) Colors.White else Colors.DarkBlue

    Link(
        path = path,
        text = text,
        modifier = Modifier
            .color(linkColor)
            .fontFamily(INTER)
            .textDecorationLine(TextDecorationLine.None)
            .fontSize(16.px)
    )
}

@Composable
fun NavLinkSidebar(
    text: String,
    path: String,
    onClose: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val linkColor = if (isDark) Colors.White else Colors.DarkBlue

    Link(
        path = path,
        modifier = Modifier
            .color(linkColor)
            .fontFamily(INTER)
            .fontSize(18.px)
            .fontWeight(FontWeight.Medium)
            .textDecorationLine(TextDecorationLine.None)
            .onClick { onClose() }
    ) {
        Text(text)
    }
}